import Hero from "../components/Hero";
import Mission from "../components/Mission";
import PastorMessage from "../components/PastorMessage";
import ServiceHighlight from "../components/ServiceHighlight";
import TestimonyPreview from "../components/TestimonyPreview";
import ContactSection from "../components/ContactSection";
import JourneyTimeline from "../components/JourneyTimeline";

export default function Home() {
  return (
    <div className="w-full bg-white">
      
      <Hero title="Moriah Church, Prarthana Bhawan"
  description="Moriah Church is a loving faith community where people encounter God, grow as disciples, and are equipped to live out their calling with integrity and purpose."
/>
<JourneyTimeline />
      {/* <AboutHighlight /> */}
      <ServiceHighlight />
      <Mission />
        <TestimonyPreview />
      <PastorMessage />
     
      {/* <GalleryPreview /> */}
     
      <ContactSection />
    </div>
  );
}
